import React, { useEffect, useState, FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

//Components
import { Button, Container, Form } from 'react-bootstrap';
import ActivityLoading from '../common/ActivityLoading';
import { UserInterface } from '../common/Types';
import ActivityToast from '../common/ActivityToast';

//Services
import { createUser, getUserById, /* getUsers, */ updateUser } from '../../services/UserService';

//Styles
import '../common/styles.scss'

const schema = yup.object().shape({
    // user_role: yup.string().required("El campo 'Rol del usuario' es requerido"),
    name: yup.string().required("El campo 'Nombre(s)' es requerido"),
    // last_name: yup.string().required("El campo 'Apellidos' es requerido"),
    // date_of_birth: yup.string().required("El campo 'Fecha de nacimiento' es requerido"),
    key_code: yup.string().required("El campo 'Clave' es requerido"),
    // address: yup.string().required("El campo 'Dirección' es requerido"),
    // home_phone: yup.string().required("El campo 'Teléfono de casa' es requerido"),
    // cell_phone: yup.string().required("El campo 'Teléfono celular' es requerido"),
    // emergency_contact: yup.string().required("El campo 'Contacto en caso de emergencia' es requerido"),
    // emergency_phone_number: yup.string().required("El campo 'Teléfono en caso de emergencia' es requerido"),
    email: yup.string().required("El campo 'Correo electrónico' es requerido"),
});

const defaultValues: any = {
    // user_role: "",
    name: "",
    last_name: "",
    date_of_birth: "",
    key_code: "",
    address: "",
    home_phone: "",
    cell_phone: "",
    emergency_contact: "",
    emergency_phone_number: "",
    email: "",
    group_id: "",
    group_name: "",
    binnacle: false,
    release_letter: false,
    reflection: false,
    poster: false,
    presentation: false,
};

interface ToastOptionsInterface {
    open: boolean,
    message: string
}

const NewUser: FC = (props: any) => {
    const { location } = props;

    const [action, setAction] = useState("create");
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState<UserInterface | undefined>(undefined);
    const [toastOptions, setToastOptions] = useState<ToastOptionsInterface>({ open: false, message: "" });

    const history = useHistory();

    const { control, setValue, formState, handleSubmit } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });
    const { errors } = formState;

    useEffect(() => {
        setLoading(true);

        const locationSplit = location.pathname.split('/')
        if (locationSplit[2] === "edit") {
            setAction("update")
            fetchUsers(locationSplit[3]);
        } else {
            setUser({} as UserInterface);
        }
    }, [location])

    useEffect(() => {
        if (user) {
            // setValue('user_role', user.user_role ? user.user_role : "");
            setValue('name', user.displayName ? user.displayName : "");
            // setValue('last_name', user.last_name ? user.last_name : "")
            // setValue('date_of_birth', user.date_of_birth ? user.date_of_birth : "")
            setValue('key_code', user.code ? user.code : "");
            // setValue('address', user.address ? user.address : "")
            // setValue('home_phone', user.home_phone ? user.home_phone : "")
            // setValue('cell_phone', user.cell_phone ? user.cell_phone : "")
            // setValue('emergency_contact', user.emergency_contact ? user.emergency_contact : "")
            // setValue('emergency_phone_number', user.emergency_phone_number ? user.emergency_phone_number : "")
            setValue('email', user.email ? user.email : "");
            // setValue('binnacle', user.binnacle ? user.binnacle : false)
            // setValue('release_letter', user.release_letter ? user.release_letter : false)
            // setValue('reflection', user.reflection ? user.reflection : false)
            // setValue('poster', user.poster ? user.poster : false)
            // setValue('presentation', user.presentation ? user.presentation : false)
            setLoading(false);
        }
    }, [user, setValue])

    const fetchUsers = (userId: string) => {
        if (!userId || userId === "error") {
            setToastOptions({ open: true, message: "Ha ocurrido un error" });
            setLoading(false);
            return;
        }

        getUserById(userId).then((response: any) => {
            setUser(response as UserInterface);
        })
    }

    const onSubmit = (userData: UserInterface) => {
        setLoading(true);
        const payload: UserInterface = {
            // user_role: userData.user_role,
            displayName: userData.name?.trim(),
            // last_name: userData.last_name,
            // date_of_birth: userData.date_of_birth,
            code: userData.key_code?.trim(),
            // address: userData.address,
            // home_phone: userData.home_phone,
            // cell_phone: userData.cell_phone,
            // emergency_contact: userData.emergency_contact,
            // emergency_phone_number: userData.emergency_phone_number,
            email: userData.email.trim(),
            // admin: userData.user_role === "admins" ? true : false,
            deleted: false,
            // binnacle: userData.binnacle,
            // release_letter: userData.release_letter,
            // reflection: userData.reflection,
            // poster: userData.poster,
            // group_id: userData.group_id ? userData.group_id : "",
            // group_name: userData.group_name ? userData.group_name : "",
            // presentation: userData.presentation
        }
        if (action === "update" && user) {
            updateUser(user.id, payload)
                .then((response: string) => {
                    if (response !== "error") {
                        history.push({ pathname: `/users` });
                    } else {
                        setToastOptions({ open: true, message: "Ha ocurrido un error" });
                        setLoading(false);
                    }
                });
        } else {
            createUser(payload).then((response: string) => {
                if (response !== "error") {
                    history.push({ pathname: `/users` });
                } else {
                    setToastOptions({ open: true, message: "Ha ocurrido un error" });
                    setLoading(false);
                }
            });
        }
    }

    const handleToastClose = (data: any) => {
        setToastOptions({ open: false, message: "" });
    }

    if (loading)
        return <ActivityLoading />

    return (
        <Container>
            <ActivityToast {...toastOptions} onClose={handleToastClose} autohide={4000} />
            <div style={{ marginBottom: '10px' }}>
                <h1>Usuario</h1>
            </div>
            <Button
                type="submit"
                variant="outline-primary"
                aria-label="save"
                className="return-button"
                onClick={() => history.goBack()}
            >
                {`Regresar`}
            </Button>
            <form className="flex flex-col justify-center w-full" onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="activityName">
                            <Form.Label>Nombre(s)</Form.Label>
                            <Form.Control
                                {...field}
                                isInvalid={!!errors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.name?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                />
                <Controller
                    name="key_code"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="activityName">
                            <Form.Label>Clave</Form.Label>
                            <Form.Control
                                {...field}
                                isInvalid={!!errors.key_code}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.key_code?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                />
                <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="activityName">
                            <Form.Label>Correo electrónico</Form.Label>
                            <Form.Control
                                {...field}
                                isInvalid={!!errors.email}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.email?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                />
                <div style={{ marginBottom: '10px', marginTop: '20px' }}>
                    <Button variant="primary" type="submit" aria-label="save">
                        Guardar usuario
                    </Button>
                </div>
            </form>
        </Container>
    )
}

export default NewUser;
